<template>
  <div class="div" v-loading="loading" style="padding: 0px">
    <!-- <div class="title">备件气价格表</div> -->
    <div class="div-top">
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        clearable
        v-model="searchData.Keyword"
        placeholder="请输入设备名称/编号"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-date-picker
        v-model="searchData.iYearMonth"
        format="yyyyMM"
        value-format="yyyyMM"
        type="month"
        style="width: 300px; margin-left: 10px"
        placeholder="请选择月份"
      >
      </el-date-picker>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button
        type="primary"
        @click="handleCompute"
        style="margin-left: 10px"
        icon="el-icon-finished
"
        >计算</el-button
      >
      <el-button
        type="warning"
        @click="handleExport"
        style="margin-left: 10px"
        icon="el-icon-download"
        >下载气消耗模板</el-button
      >
      <Upload
        :text="'导入气消耗模板'"
        style="margin-left: 10px"
        ref="Upload"
        :uploadUrl="
          $rootUrl + '/Base/GasConsumption/ImportDevice_FixedAssetsToDataBase'
        "
        @success="handleSearch"
      ></Upload>
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 50px)"
        @selection-change="handleSelect"
      >
        <el-table-column label="" width="50" type="selection">
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <el-table-column
          label="年月"
          align="center"
          prop="iYearMonth"
          sortable
          width="120"
        >
        </el-table-column>
        <el-table-column
          label="设备编号"
          align="center"
          prop="DeviceCode"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="设备名称"
          align="center"
          prop="DeviceName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="气消耗"
          align="center"
          prop="GasConsumptionQty"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.GasConsumptionQty
                ? JSON.parse(scope.row.GasConsumptionQty)
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="平均价" align="right" prop="AvgPrice" sortable>
          <template slot-scope="scope">
            {{ tools.momenyFormat(scope.row.AvgPrice, 2) }}
          </template>
        </el-table-column>
        <el-table-column label="金额" align="right" prop="Amount" sortable>
          <template slot-scope="scope">
            {{ tools.momenyFormat(scope.row.Amount, 2) }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

import tools from '@/utils/tools.js'
import Upload from '@/components/Upload/Upload.vue'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      moment,
      tools,
      searchData: {
        Condition: 'DeviceName',
        Keyword: '',
        iYearMonth: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { Upload },
  methods: {
    handleCompute() {
      if (!this.searchData.iYearMonth) {
        this.$notify.error('请选择月份后进行计算')
        return
      }
      this.$confirm(
        `此操作将计算${this.searchData.iYearMonth}月份气消耗, 是否继续?`,
        {
          type: 'warning',
        }
      )
        .then(() => {
          this.loading = true
          this.$http
            .post(
              '/Base/GasConsumption/CalculateCost?iYearMonth=' +
                this.searchData.iYearMonth,
              {}
            )
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('计算成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleExport() {
      tools.download(
        this.$rootUrl + '/Base/Base_GasPrice/ExportAccessoryToExcel',
        '气消耗模板',
        '.xlsx',
        'get'
      )
    },
    selectable(row) {
      return row.Status == 0
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base/GasConsumption/GetGasConsumptionDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'DeviceName',
              Keyword: this.searchData.Keyword || '',
            },
            {
              Condition: 'iYearMonth',
              Keyword: this.searchData.iYearMonth || '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建气价格表')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该设备气消耗, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base/GasConsumption/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row, num) {
      if (num == 1) {
        this.$refs.EditForm.openForm('气价格表详情', row, true)
        return
      }
      if (num == 2) {
        this.$refs.EditForm.openForm('审核气价格表详情', row, true)
        return
      }
      this.$refs.EditForm.openForm('编辑气价格表', row, false)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
